import { Page } from "@/components/PublicLayout";
import { ContentBody } from "@/components/ContentBody";
import { useBlocks } from "@/hooks/useContent";

const LegalPage = ({ blockKey, fallbackTitle, testId }) => {
  const { data: blocks } = useBlocks();
  const block = blocks?.[blockKey];
  const draft = block?.body?.startsWith("[DRAFT");
  const body = draft ? block.body.replace(/^\[DRAFT[^\]]*\]\s*/, "") : block?.body || "";
  return (
    <Page title={block?.title || fallbackTitle} testId={testId}>
      {draft && <p className="mb-8 inline-block rounded border border-sage-400 bg-cream-100 px-3 py-1.5 text-sm text-ink-500" data-testid="draft-marker">Draft — counsel review required before launch</p>}
      <ContentBody body={body} />
      {block?.updated_at && <p className="help mt-10">Last updated {new Date(block.updated_at).toLocaleDateString("en-US", { timeZone: "America/Los_Angeles" })}</p>}
    </Page>
  );
};

export const PrivacyPage = () => <LegalPage blockKey="privacy.body" fallbackTitle="How We Protect Your Information" testId="privacy-page" />;
export const TermsPage = () => <LegalPage blockKey="terms.body" fallbackTitle="Terms" testId="terms-page" />;
export const SmsTermsPage = () => <LegalPage blockKey="sms_terms.body" fallbackTitle="SMS Terms" testId="sms-terms-page" />;
export const AccessibilityPage = () => <LegalPage blockKey="accessibility.body" fallbackTitle="Accessibility" testId="accessibility-page" />;
